import { Required, IsString, IsNumber, DataValidator, transformKeys, IsArray } from "@/utils/type-vaildator";
import api from "./api";
import { AiMakeMessageRecordData } from "./ai-make-source-record-list-by-type";
import { ScriptReplaceMark } from "./make-generate";

interface PushInfoOriginDataRecordListResponse {
  data: any[];
}

export class ThinkingData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @IsString("Title must be a string")
  title: string;

  @IsString("Content must be a string")
  content: string;

  @IsNumber("Start at must be a number")
  startAt: number;

  @IsNumber("Create time must be a number")
  createTime: number;

  @IsNumber("Type must be a number")
  type: number;

  @IsString("Task id must be a string")
  task_id: string;

}

export class MessageItemData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @IsNumber("Agent id must be a number")
  agentId?: number;

  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;

  @IsString("Title must be a string")
  title?: string;

  @IsString("Content must be a string")
  content?: string;

  @IsString("Input text must be a string")
  inputText?: string;

  @IsString("Cover image url must be a string")
  coverImageUrl?: string;

  @IsString("Video url must be a string")
  videoUrl?: string;

  @IsString("Image urls must be a string")
  imageUrls?: string;

  @IsString("Audio url must be a string")
  audioUrl?: string;

  @IsNumber("Created at must be a number")
  createdAt?: number;

  @IsString("Task id must be a string")
  taskId?: string;

  @IsNumber("Status must be a number")
  status?: number;

  @IsNumber("Video duration must be a number")
  videoDuration?: number;

  @IsNumber("Audio duration must be a number")
  audioDuration?: number;

  @IsString("Summary must be a string")
  summary?: string;

  @IsString("Image urls must be a string")
  reqBody?: string;

  @IsString("Note name must be a string")
  noteName?: string;

  @IsString("Link url must be a string")
  linkUrl?: string;

  @IsString("S3 audio url must be a string")
  s3AudioUrl?: string;

  @IsString("S3 cover image url must be a string")
  s3CoverImageUrl?: string;

  @IsString("S3 image urls must be a string")
  s3ImageUrls?: string;

  @IsString("S3 video url must be a string")
  s3VideoUrl?: string;

  @IsString("Note content title must be a string")
  noteContentTitle?: string;

  @IsArray("Thinking list must be an array")
  thinkingList?: ThinkingData[];

  @IsString("Task status must be a string")
  taskStatus?: string;

  n8nCode?: string;

  @IsString("N8n message must be a string")
  n8nMessage?: string;

  @IsString("Error message must be a string")
  errMessage?: string;

  @IsString("Input address must be a string")
  inputAddress?: string;

  @IsArray("Ai make source records must be an array")
  aiMakeSourceRecords?: AiMakeMessageRecordData[];
  
  @IsNumber("Point must be a number")
  point?: number;

  @IsArray("Marks must be an array")
  marks?: ScriptReplaceMark[];

  autoPush?: boolean;
}

export interface GetAgentMessagesRequest {
  agentId: string;
  page: number;
  pageSize: number;
  type?: "" | "1" | "2" | "3" | "4" | "5" | "6";
}

export const getAgentMessages = async ({
  agentId,
  page,
  pageSize,
  type = "",
}: GetAgentMessagesRequest): Promise<MessageItemData[]> => {
  if (!agentId) {
    throw new Error("agentId cannot be empty");
  }
  if (!["", "1", "2", "3", "4", "5", "6"].includes(type)) {
    throw new Error("type must be '', '1', '2', '3', '4', '5', or '6'");
  }
  if (page <= 0) {
    throw new Error("page must be greater than 0");
  }
  if (pageSize <= 0) {
    throw new Error("pageSize must be greater than 0");
  }

  const params: Record<string, any> = {
    agent_id: agentId,
    page,
    page_size: pageSize,
  };
  if (type !== "") {
    params.type = Number(type);
  }

  const response = await api.post<PushInfoOriginDataRecordListResponse>(
    "/push_info_origin_data_record/list",
    params
  );
  const root = transformKeys(response.data);
  const list = Array.isArray(root.data) ? root.data : [];
  return list.map((item: unknown) => {
    const data = DataValidator.validateOrThrow(item, MessageItemData);
    return {
      ...data,
      autoPush: !data.inputText && !data.linkUrl && !data.noteContentTitle
    }
  });
};
